
import { Card } from "react-bootstrap";
import { FaPencilAlt } from "react-icons/fa";
import ThemeModal from "../cmp/ThemeModal";
import { useState, useEffect } from "react";
import { Formik } from 'formik';
import { GetOrders } from "../../helpers";
import { Alerts } from "../../helpers";
import { format } from "date-fns";
const OrderNote = ({ note, order, getOrder }) => {
    const [isEdit, setEdit] = useState(false);
    const [orderNotes, setOrderNotes] = useState(order.order_notes);
    const [selectedNotes, setSelectedNotes] = useState([]);
    const [deleteMode, setDeleteMode] = useState(false);
    const handleEdit = async () => {
        setEdit(true)
    }
    const handleCloseEdit = async () => {
        setEdit(false);

    }

    const handleUpdateOrderNote = async (values, { setSubmitting }) => {
        values.orderId = order.id
        const resp = await GetOrders.addOrderNote(values);
        if (resp && resp.status) {
            setOrderNotes(prev => [resp.note, ...prev]);
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setEdit(false)
            setSubmitting(false)
        }else{
             Alerts.alertMessage('Something went wrong !', 'top-right', 'error');
        }
    }


    const handleCheckboxChange = (e, noteId) => {
        if (e.target.checked) {
            setSelectedNotes((prev) => [...prev, noteId]);
        } else {
            setSelectedNotes((prev) => prev.filter((id) => id !== noteId));
        }
    };



    const deleteSelectedNotes = async () => {
        try {
        const resp = await GetOrders.deleteOrderNote({noteIds:selectedNotes});
        if (resp && resp.status) {
              Alerts.alertMessage(resp.message, 'top-right', 'success');
              setOrderNotes((prev) => prev.filter((note) => !selectedNotes.includes(note.id)));
              setSelectedNotes([]);
              setDeleteMode((prev) => !prev)
        }else{
             Alerts.alertMessage('Something went wrong !', 'top-right', 'error');
        }

        } catch (error) {
            console.error(error);
        }
    };
    return (
        <>
            <Card style={{ marginTop: 30 }}>
                <Card.Header className='cartHeaderTop'>
                    <h6>Order Note</h6>
                    <div className="d-flex align-items-center gap-3">
                        {
                            order.payment_status !== 'refunded' && <button onClick={handleEdit} style={{ color: '#7c7c7c' }}><FaPencilAlt /></button>
                        }
                        {
                            orderNotes && orderNotes.length > 0 && <button onClick={() => {
                            setSelectedNotes([])
                            setDeleteMode((prev) => !prev)
                        }} style={{ color: deleteMode ? "red" : "#7c7c7c" }}>
                            {deleteMode ? "Cancel" : "✖"}
                        </button>
                        }
                        
                    </div>

                </Card.Header>
                <Card.Body>
                    <p style={{ fontSize: 13 }}>{note}</p>
                    {
                        orderNotes && orderNotes.length > 0 && orderNotes.map((noteData, j) => {
                            const date = new Date(noteData.createdAt);
                            const formatted = format(date, "dd MMM yyyy, hh:mm a");
                            return <div key={noteData.id} style={{ display: "flex", alignItems: "center", marginBottom: 3 }}>
                                {deleteMode && (<input
                                    type="checkbox"
                                    value={noteData.id}
                                    checked={selectedNotes.includes(noteData.id)}
                                    onChange={(e) => handleCheckboxChange(e, noteData.id)}
                                    style={{ marginRight: 8, minHeight:25 }}
                                />)}
                                <p style={{ fontSize: 13, marginBottom:10 }}>{noteData.note} <br/> <span style={{fontSize:12, color:'#08464c'}}>{formatted}</span> </p>
                            </div>
                        })
                    }

                    {selectedNotes.length > 0 && (
                        <button onClick={deleteSelectedNotes} className="btn btn-danger btn-sm mt-3">
                            Delete Selected ({selectedNotes.length})
                        </button>
                    )}
                </Card.Body>
            </Card>
            <ThemeModal show={isEdit} handleHide={handleCloseEdit} title="Add Order Note" size="md" centered={true}>
                <Formik
                    enableReinitialize
                    initialValues={{ orderNote: '' }}
                    validate={values => {
                        const errors = {};
                        if (!values.orderNote) {
                            errors.orderNote = 'Please enter a note !';
                        }
                        return errors;
                    }}
                    onSubmit={handleUpdateOrderNote}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        /* and other goodies */
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <textarea
                                    placeholder="Enter order note.."
                                    className="form-control"
                                    rows={5}
                                    name="orderNote"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.orderNote}
                                >

                                </textarea>
                                {errors.orderNote && touched.orderNote && <span className="help-error">{errors.orderNote}</span>}
                            </div>
                            <div className="text-center">
                                <button className="btn btn-info btn-sm" type="submit" disabled={isSubmitting}>
                                    {
                                        isSubmitting ? 'Please wait..' : 'Add Now'
                                    }
                                </button>
                            </div>
                        </form>
                    )}
                </Formik>
            </ThemeModal>
        </>

    )
}
export default OrderNote;